// extracted by mini-css-extract-plugin
module.exports = {"block":"_8939","icon":"_10542","label":"_17220","count":"_18440","more":"_765","text":"_14608","arrow":"_18269"};